import logo from './logo.svg';
import './App.css';
import { Layout, Menu, Row, Col, Card, Typography } from 'antd';
import { HomeOutlined, MessageOutlined, CloudOutlined } from '@ant-design/icons';  // Import icons for menu items

//import 'antd/dist/antd.css';  // Import Ant Design styles by adding this line
import PowerConsumptionCalculator from './PowerConsumptionCalculator'; // Assuming you've created this component

const { Title } = Typography;
const { Text } = Typography;

const { Header } = Layout;

const TopBarHeader = () => (
  <Header style={{
    lineHeight: '64px',
    padding: '0 10px',
    background: 'white',
    margin: '10px 20px',
    borderRadius: '10px'
    }}>
    <Row justify="space-between" align="middle" style={{ height: '100%', background: 'transparent' }}>
      <Col flex="none">
        <a href="https://www.signageos.io">
        <img src={`${process.env.PUBLIC_URL}/signageOS-full-white.png`} alt="signageOS Logo" style={{ height: '60px', verticalAlign: 'middle' }} />
        </a>
      </Col>
      <Col xs={24} sm={12} md={18} style={{background: 'transparent'}}>
        <Menu mode="horizontal" theme="light" style={{ lineHeight: '64px', background: 'transparent', justifyContent: 'flex-end' }}>
          <Menu.Item key="home" icon={<HomeOutlined />}>
            <a href="https://www.signageos.io" target="_blank" rel="noopener noreferrer">
              Back to home
            </a>
          </Menu.Item>
          <Menu.Item key="explore" icon={<CloudOutlined />}>
            <a href="https://www.signageos.io/solutions/device-management" target="_blank" rel="noopener noreferrer">
              Explore CloudControl
            </a>
          </Menu.Item>
          <Menu.Item key="contact" 
              icon={<MessageOutlined style={{ color: '#18182c'}} />}
              style={{ backgroundColor: '#fbc01d', borderRadius: '4px', marginRight: '-10px' }}>
              <a href="https://calendly.com/d/5hy-ks4-5mm/signageos-cloudcontrol-exploration?month=2024-05"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#18182c', fontWeight: 'bold', padding: '5px 10px' }}>
                  Get in touch
              </a>
          </Menu.Item>
        </Menu>
      </Col>
    </Row>
  </Header>
);

const Footer = () => (
  <Row style={{textAlign: "left", display: 'flex', marginTop: '16px'}} gutter={16}>
          <Col span={12} style={{ paddingBottom: '16px', display: 'flex' }}>
              <Card className='semi-transparent card-style'>
                      <Text>
                          <b>How to use</b><br/>
                          <ul>
                              <li>
                                  In each section select number of displays, their brightness and how long they run every day.
                              </li>
                              <li>
                                  Adjust price of electricity per kWh
                              </li>
                              <li>
                                  Click Calculate
                              </li>
                              <li>
                                  Review aggregated power consumption as well as per-display type consumptions.
                              </li>
                              
                          </ul>

                      </Text>
              </Card>
          </Col>
          <Col span={12} style={{ paddingBottom: '16px', display: 'flex' }}>
              <Card className='semi-transparent card-style'>
                      <Text>
                          <b>Disclaimer</b><br/>
                          Calculator is meant for rough estimates on electricity consumption of different displays.<br/>
                          Values are based on general approximation and real energy consumption may differ.<br/>
                          signageOS is not responsible for any issues or miscalculations.<br/>
                          signageOS is not collecting any data filled in this form.
                      </Text>
              </Card>
          </Col>
          <Col span={24} style={{ paddingBottom: '16px' }}>
              <Card className='semi-transparent card-style'>
                      <Text>
                      Copyright © 2024  All Rights Reserved by <a href="https://www.signageos.io">signageOS</a>
                      </Text>
              </Card>
          </Col>
  </Row>
);

function App() {
  return (
    <Layout className="layout gradient-background">
      <video autoPlay muted loop style={{
                position: 'absolute',
                right: '0',
                bottom: '0',
                minWidth: '100%',
                minHeight: '100%',
                zIndex: '-1',
                backgroundImage: `url(${process.env.PUBLIC_URL}/bg.jpg)`
            }}>
                <source src={`${process.env.PUBLIC_URL}/bg.mp4`} type="video/mp4" />
                Your browser does not support the video tag.
      </video>
      <TopBarHeader />
      <div className="App">
        <PowerConsumptionCalculator />
        <Footer />
      </div>
   </Layout>
  );
}

export default App;
